import request from '@/utils/request'

export function del(query) {
  return request({
    url: '/api/station/delOilTankRecord',
    method: 'post',
    params: query
  })
}